<script setup lang="ts">
import SvgIcon from '@/components/common/SvgIcon.vue'
import { useAppRouter } from '@/shared/composables/useAppRouter'
import { EPage } from '@/shared/enum/page.enum'
import { ESprites, ESpritesUI } from '@/shared/enum/sprites.enum'

const { navigateToRoute } = useAppRouter()

const goToSendPackage = () => {
  navigateToRoute(EPage.SEND_RECHARGES)
}
</script>

<template>
  <button
    id="landing-send-rechargine"
    data-testid="qa_landing_send_rechargine"
    class="flex flex-col items-center justify-center gap-2 align-middle border rounded-lg shadow-md cursor-pointer landing__button"
    itemprop="potentialAction"
    itemscope
    itemtype="http://schema.org/Action"
    @click="goToSendPackage"
  >
    <span
      class="self-center block px-1 text-sm font-bold leading-none sm:text-base"
      itemprop="name"
    >
      Enviar Recargas o Superpacks a Familiares y Amigos
    </span>
    <div class="justify-self-center">
      <SvgIcon
        :file="ESprites.UI"
        :name="ESpritesUI.RECHARGINE"
        width="48"
        height="48"
        class="w-12 h-12 text-grey-900"
      />
    </div>
  </button>
</template>

<style scoped></style>
